<template>
 <modal modal-classes="modal-lg" :show.sync="modals.add_project" :key="islogin">
    <template slot="header">
      <h5 class="modal-title" id="exampleModalLabel">{{ modal_add_title }}</h5>
    </template>
    <div>
      <div class="col-md-12" v-if="islogin==false">
        <p v-if="!($route.query && $route.query.nextUrl && $route.query.nextUrl.length>0)">Нажмите кнопку ниже</p>
        <p v-if="($route.query && $route.query.nextUrl && $route.query.nextUrl.length>0)">Для доступа к {{ $route.query.nextUrl }} необходимо авторизоваться</p>

        <p><a @click="LoginFromBot" target="_blank"
              :href="'https://t.me/'+telegram_bot+'?start=login'+random_code"
              class="btn side4">Авторизоваться через
          Telegram
          Бота</a></p>

        <p>Авторизация через виджет:</p>
        <vue-telegram-login v-if="istgbot"  id="telegram_login"
                            mode="callback"
                            requestAccess="write"
                            :telegram-login="telegram_bot"

                            @callback="telegramLoginCallback"/>

        <p v-if="timer_check_code!=''">Каждые 2 секунды происходит обновление на проверку состояния авторизации</p>


      </div>

      <div class="alert alert-danger" v-if="iserror==true && islogin==true">
        <p>{{ error_message }}</p>
      </div>
      <div class="form-group row" v-if="islogin==true && modal_params.add_project && modal_params.add_project==true && user.isdeveloper && user.isdeveloper==1">
        <div class="col-md-6">
          <label for="exampleCategory22">Создать проект,только для себя</label>
        </div>
        <div class="col-md-4">
          <input type="checkbox" class="form-control" value="1" v-model="form.i_am_client_and_developer" />
        </div>


      </div>
      <div class="form-group" v-if="islogin==true && is_show_category==true">
        <label for="exampleCategory5">Тип </label>
        <select id="exampleCategory5" v-if="loaded_categorys==true" v-model="form.category" required
                class="form-control">
          <option v-if="categorys[0].name" v-for="category in categorys" :value="category.last_id"
                  :key="category.last_id">{{
              category.name
            }}
          </option>


          <option v-if="categorys[0].title && modal_params.type == 'post_new'  && ( (modal_params.is_project && modal_params.is_project==false) || !modal_params.is_project)" v-for="category in categorys" :value="category.last_id"
                  :key="category.last_id">{{
              category.title
            }}
          </option>

          <option v-if="categorys[0].title && modal_params.type == 'post_new' && modal_params.is_project &&  modal_params.is_project==true"   :value="modal_params.blog_category_row.last_id"
                   >{{
              modal_params.blog_category_row.title
            }}
          </option>
          <option v-if="categorys[0].title && modal_params.type == 'post_edit'"   :value="modal_params.blog_category_row.last_id"
          >{{
              modal_params.blog_category_row.title
            }}
          </option>


        </select>


      </div>
      <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem') ">
        <label >Название </label>
        <input type="text" class="form-control " v-model="form.title">
      </div>
      <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
        <label for="exampleCategoryitem">Категория </label>
        <select id="exampleCategoryitem" v-if="(modal_params.type=='additem' || modal_params.type=='edititem')" v-model="form.category_id" required
                class="form-control">

          <option v-if="(modal_params.type=='additem' || modal_params.type=='edititem')  && modal_params.categorys.length>0" v-for="category in modal_params.categorys" :value="category.last_id"
                  :key="category.last_id">{{
              category.title
            }}
          </option>



        </select>


      </div>
      <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
        <label >Цена </label>
        <input type="text" class="form-control " v-model="form.price">
      </div>
      <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
        <label for="exampleCategoryitem56">Валюта </label>
        <select id="exampleCategoryitem56" v-if="(modal_params.type=='additem' || modal_params.type=='edititem')" v-model="form.currency" required
                class="form-control">

          <option v-if="(modal_params.type=='additem' || modal_params.type=='edititem')  && currencys.length>0" v-for="(currency,currency_key) in currencys" :value="currency"
                  :key="currency_key">{{
              currency
            }}
          </option>



        </select>


      </div>
      <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
        <label >Загрузите изображение </label>
        <input type="file" accept="image/*" @change="uploadImageItem($event)" id="file-input">

      </div>
      <div class="col-3" v-if="(modal_params.type=='additem' || modal_params.type=='edititem') && form.photos.length>0" v-for="(photo,photo_key) in form.photos"
           :key="photo_key">
        <p class="mt-2"><img :src='photo' class="img img-thumbnail" ><button class="btn btn-success" @click="deletePhoto(photo_key)" type="button">Удалить</button></p>
      </div>
      <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
        <label >Количество </label>
        <input type="text" class="form-control " v-model="form.count">
      </div>
      <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
        <label >Подзаказ? </label>
        <input type="checkbox" class="form-check-inline " v-model="form.islimited">
      </div>
      <div class="col-12 alert alert-warning" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
        <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
          <label >Название опции </label>
          <input type="text" class="form-control " v-model="shop_new_option.title">
        </div>
        <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
          <label >Стоимость </label>
          <input type="number" class="form-control " v-model="shop_new_option.price">
        </div>
        <div class="form-group" v-if="islogin==true && (modal_params.type=='additem' || modal_params.type=='edititem')">
          <button type="button" class="btn btn-success"  @click="addNewOptions()">Добавить опцию</button>

        </div>

        <div v-if="form.options.length>0 && (modal_params.type=='additem' || modal_params.type=='edititem')" v-for="(option,option_key) in form.options"
             :key="option_key">
          <p class="mt-2"><b>{{ option.title}}</b> {{ option.price }} {{form.currency}} <button class="btn btn-success" @click="deleteOption(option_key)" type="button">Удалить</button></p>
        </div>
      </div>

      <div class="form-group " v-if="modal_params.is_project">
        Пост закреплен?
        <input type="checkbox" v-model="form.is_pinned" value="1"/>
      </div>
      <div class="form-group" v-if="modal_params.iswork">
        <label for="exampleDateStart">Дата начала </label>
        <input type="date" id="exampleDateStart" class="form-control" v-model="modal_params.newWork.date_start"
               required/>
      </div>
      <div  v-if="modal_params.type=='addlead' && modal_params.fields.length>0">
        <div class="form-group"  v-if="modal_params.fields.length>0" v-for="field in modal_params.fields"
             :key="field.last_id">
          <label for="exampleDateStart" v-if="!(field.type=='image' || field.type=='file')">{{ field.title}} </label>

          <input type="text" v-if="field.type=='string'"  class="form-control" :name="field.name" v-model="modal_params.fields_value[field.name]"
          />
          <input type="number" v-if="field.type=='integer'"  class="form-control" v-model="modal_params.fields_value[field.name]"
          />
          <input type="text" v-if="field.type=='stroka'" class="form-control" v-model="modal_params.fields_value[field.name]"/>
          <select  multiple="multiple" v-if="field.type=='multi'" class="form-control" v-model="modal_params.fields_value[field.name]">
            <option v-if="field.options.length>0" v-for="(option,index) in field.options"
                    :key="index" :value="option">{{ option}}</option>
          </select>
          <select    v-if="field.type=='select'" class="form-control" v-model="modal_params.fields_value[field.name]">
            <option v-if="field.options.length>0" v-for="(option,index) in field.options"
                    :key="index" :value="option">{{ option}}</option>
          </select>

        </div>

      </div>
      <div class="form-group" v-if="modal_params.iswork">
        <label for="exampleDateEnd">Дата завершения </label>
        <input type="date" id="exampleDateEnd" class="form-control" v-model="modal_params.newWork.date_end"
               required/>
      </div>
      <div class="form-group" v-if="modal_params.iswork">
        <label for="exampleCategory">Категория </label>
        <select id="exampleCategory" v-if="loaded_categorys==true" v-model="modal_params.newWork.category"
                required
                class="form-control">
          <option v-for="category in categorys" :value="category.last_id" :key="category.last_id">
            {{ category.name }}
          </option>

        </select>


      </div>
      <div   v-if="modal_params && modal_params.project && modal_params.project.fields && modal_params.project.fields.length>0">
        <div class="row form-group"  v-for="field in modal_params.project.fields"   :key="field.last_id">
          <div class="col-md-6">
            <label for="exampleCategory">{{ field.title}} </label>
          </div>
          <div class="col-md-6">
            <select  id="exampleCategory" v-if="field.type=='select' || field.type=='selectinsert'" v-model="form.fields[field.name]"

                     class="form-control">
              <option value="null" v-if="field.type=='selectinsert'">Создать новый</option>
              <option v-for="value in field.values" :value="value.last_id" :key="value.last_id">
                {{ value[field.key_title] }}
              </option>

            </select>
            <input class="form-control" type="text"  v-if="field.type=='selectinsert' && form.fields[field.name]=='null' " v-model="form.fields[field.name+'_input']"/>
            <input class="form-control" type="number" v-if="field.type=='number'" v-model="form.fields[field.name]"/>
            <input class="form-control" type="text" v-if="field.type=='stroka'" v-model="form.fields[field.name]"/>
          </div>






        </div>

      </div>



      <div class="form-group row"
           v-if="islogin==true && modal_params.is_edit_share && modal_params.is_edit_share==true">
        <label for="exampleUser">Исполнитель задачи</label>
        <select id="exampleUser" required v-model="form.new_developer_id"
                class="form-control">


          <option

              v-for="user_project in modal_params.project.main_users"
              :value="user_project.last_id"
              :key="user_project.last_id">@{{
              user_project.name
            }}
          </option>

        </select>


      </div>

      <div class="form-group row"
           v-if="islogin==true && modal_params.is_edit_share && modal_params.is_edit_share==true">
        <label for="exampleUser">Проверяющий задачу</label>
        <select id="exampleUser" required v-model="form.new_client_id"
                class="form-control">


          <option

              v-for="user_project in modal_params.project.main_users"
              :value="user_project.last_id"
              :key="user_project.last_id">@{{
              user_project.name
            }}
          </option>

        </select>


      </div>

      <div class="form-group row"
           v-if="islogin==true && modal_params.type_user && modal_params.type_user=='developer' && is_add_task && modal_params.project &&  modal_params.project.developer_id>0">
        <label for="exampleUser">Исполнитель задачи</label>
        <select id="exampleUser" required v-model="new_task_developer"
                class="form-control">
          <option value="me">Я</option>

          <option
              v-if="user_project.last_id!=user.last_id && user_project.isapprove==1 && user_project.role=='spectator'"
              v-for="user_project in modal_params.users"
              :value="user_project.last_id"
              :key="user_project.last_id">@{{
              user_project.name
            }}
          </option>

        </select>


      </div>

      <Editor v-if="islogin==true && is_disable_editor==false" ref="editor" :config="config"/>


    </div>
    <template slot="footer">
      <base-button type="secondary" @click="modals.add_project = false">Закрыть</base-button>

      <base-button v-if="islogin" @click="invokeSave" type="primary">{{ modal_btn_add_project }}</base-button>
    </template>
  </modal>

</template>

<script>
import {vueTelegramLogin} from "vue-telegram-login";
import {eventBus} from "../main";
import Api from "../models/Api";
import Vue from "vue";
import axios from "axios";
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import BaseNotifyDropdown from "@/components/BaseNotifyDropdown";
import CloseButton from "@/components/CloseButton";
import MapPlugin from "../models/MapPlugin";

import {vm} from "../main.js";
import Modal from "@/components/Modal";
import UserModel from "../models/UserModel";

export default {
  name: "LoginModal",
  components: {
    Modal,
    BaseNav,
    CloseButton,
    BaseDropdown,
    BaseNotifyDropdown,
    vueTelegramLogin
  },
  data: function () {
    return {
      'categorys_blog':{},
      loaded_blog_category:false,
      "telegram_bot": null,
      is_disable_editor:false,
      user: {},
      is_load_pages: false,
      pages: [],
      random_code: '',
      funnels:[],
      "shop_new_option":{
        "title":"",
        "price":0,
      },
      is_notify_load: false,
      new_task_developer: null,
      "loaded_categorys": false,
      "categorys": null,
      "notifys": null,
      "notify": {
        "show_only_unread": true,
      },
      'modal_params': {},
      "modals": {
        "add_project": null,
      },
      "notify_counts": {
        "projects": 0,
        "freelance": 0,
        "comments": 0,
        "invoices": 0,
      },
      "modal_add_title": "Размещение проекта",
      "is_show_category": true,
      "is_add_task": false,
      "is_add_item":false,
      "iserror": false,
      "error_message": null,
      "modal_btn_add_project": "Отправить на оценку",
      "form": {
        'category': null,
        'json': {},
        'fields':{},
      },
      "config": {},
      notify_count: 0,
      islogin: false,
      'istgbot': false,
      'timer': '',
      'timer_check_code': '',
      show_modal_after_login: true,
      "currencys":null,
      "total_cart_price":0,
    }
  },
  mounted: function () {
    if(this.$route.query.rand_code){
      // Api.login_by_token(this.$route.query.rand_code,function(user_data){
      //   UserModel.set(user_data)
      //
      // });
    }else {
      this.random_code = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    }


    var app=this;









    eventBus.$on("call_modal_add_project_from_root",data=>{


      this.modal_add_title = data["modal_add_title"];
      this.show_modal_after_login = data["show_modal_after_login"];
      this.is_add_task = data["is_add_task"];
      this.modal_params = data["modal_params"];
      this.is_show_category = data["is_show_category"];
      this.form.category = data["form_category"];
      this.modals.add_project = data["modals_add_project"];
      if(data["add_project"]){
        app.modal_params.add_project=true;
      }

      if (this.islogin) {
        this.$refs.editor._data.state.editor.render(this.config.data);
      }

      this.modal_btn_add_project = "Отправить на оценку";
    });
    eventBus.$on("call_modal_add_project", data => {


      if(data==undefined){
        data=[];
      }



      data.fields=[];

      data.fields_value={};
      app.is_disable_editor=false;
      app.modal_params = data;



      if(data.type && data.type=="addlead"){
        Api.loadLeadFields(function(resp){

          if(resp.fields && resp.fields.length>0){

            app.modal_params.fields=resp.fields;
          }
        })
      }
      app.loaded_categorys = false;


      if (app.modal_params.type && (app.modal_params.type == "post_new" || app.modal_params.type == "post_edit")) {
        Api.loadBlogFormCategorys(function (data) {



          if (app.modal_params.blog_category_default) {
            app.form.category = app.modal_params.blog_category_default;
            app.categorys=[app.modal_params.blog_category_row];
          }else {
            app.categorys = data;
          }

          app.loaded_categorys = true;


        });
      } else if (app.modal_params.type && (app.modal_params.type == "addwork" || app.modal_params.type == "editwork")) {
        Api.loadPortfolioCategorysModal(function (data) {
              app.is_show_category = false;
              app.categorys = data;
              app.loaded_categorys = true;
            }
        );
      } else {
        var data_new=data;

        Api.loadCategorys(function (data) {
          app.categorys = data;
          app.loaded_categorys = true;
        //  alert(data.current_form_category);
          if(data_new.current_form_category){

            app.form.category=data_new.current_form_category;
          }


        });
      }



      if (app.modal_params.type && app.modal_params.type == "edit") {

        app.editProject();
      } else if (app.modal_params.type && app.modal_params.type == "addwork") {
        app.addWork();
      } else if(app.modal_params.type && (app.modal_params.type=='additem' || app.modal_params.type=='edititem')){
        app.addItem();
      }  else if (app.modal_params.type && app.modal_params.type == "addlead") {
        app.addLead();
      }  else if (app.modal_params.type && app.modal_params.type == "editlead") {
        app.editLead();
      }else if (app.modal_params.type && app.modal_params.type == "editwork") {
        app.editWork();
      } else if (app.modal_params.type && app.modal_params.type == "addtask") {
        app.is_add_task=true;
        app.addTask();
      } else if (app.modal_params.type && app.modal_params.type == "post_new") {
        app.addPost();
      } else if (app.modal_params.type && app.modal_params.type == "post_edit") {
        app.editPost();
      } else if (app.modal_params.type && app.modal_params.type == "login") {

        app.modal_params = {};
        app.addProject(false);
      } else {
        app.addProject();
      }

      if(data && data.add_project){
        app.modal_params.add_project=data.add_project;
        if(app.user.isdeveloper && app.user.isdeveloper==1){
          app.modal_btn_add_project="Создать проект";
          app.form.i_am_client_and_developer=1;

        }


      }
    })
    app.telegram_bot = Vue.config.TG_BOT;
    app.istgbot = true;
    Api.loadCategorys(function (data) {
      app.categorys = data;
      app.loaded_categorys = true;
    });

    var tmpUser=UserModel.get();
    if(tmpUser){
      if(tmpUser.api_token) {

        this.user = tmpUser;
        this.islogin = true;
        //app.timer = setInterval(app.updateNotifyCount, 2000);
        app.updateEditorJs(this.user.api_token);
        if (app.islogin == true && app.user.islead == 1) {
          Api.loadFunnels(function (datas) {
            if (datas.funnels.length > 0) {
              app.funnels = datas.funnels;
            }
          })
        }
      }
    }
    eventBus.$on('user_is_login', user => {
      // if(app.$route.query.redirect_after){
      //
      //   //document.location.href=app.$route.query.redirect_after;
      //   //app.$router.push(app.$route.query.redirect_after)
      //   app.$router.push({path: app.$route.query.redirect_after});
      // }
      this.islogin = false;
      if (typeof user === 'object') {

        if("api_token" in user){

          if (user.api_token) {

            app.user = user;
            app.islogin = true;



            app.updateEditorJs(user.api_token);


          }
        }
      }


    });
  },
  methods: {
    deletePhoto(photo_key){

      var key=photo_key;
      var app=this;
      if(app.form.photos[key]){
        app.form.photos.splice(key, 1);

      }
    },
    deleteOption(option_key){

      var key=option_key;
      var app=this;
      if(app.form.options[key]){
     app.form.options.splice(key, 1);

      }
    },
    uploadImageItem(){


      var app=this;

      let data = new FormData();
      data.append("image",event.target.files[0]);

      // let config = {
      //   header : {
      //     'Content-Type' : 'image/png'
      //   }
      // }
      Api.loadImage(data,function(data){

      app.form.photos.push(data.file.url);

      })

      // axios.put(
      //     URL,
      //     data,
      //     config
      // ).then(
      //     response => {
      //
      //     }
      // )
    },
    addNewOptions(){
      var app=this;
      var new_option=app.shop_new_option;

      if(new_option.title.length>0 ){
        app.form.options.push({"title":new_option.title,"price":new_option.price});
        app.shop_new_option.title="";
        app.shop_new_option.price=0;

      }
    },
    testLog() {

    },
    changeNotifyType() {
      this.loadNotify();
    },
    LoginFromBot() {
      var app = this;

      app.LoginCheckCode();
      app.timer_check_code = setInterval(app.LoginCheckCode, 2000);
    },
    updateEditorJs(api_token="") {
      this.config = {

        tools: {

          header: require('@editorjs/header'),
          list: {
            class: require('@editorjs/list'),
            inlineToolbar: true,
          },
          "code": require('@editorjs/code'),
          inlineCode: {
            class: require('@editorjs/inline-code'),
            shortcut: 'CMD+SHIFT+M',
          },

          embed: require('@editorjs/embed'),
          linkTool: {
            class: require('@editorjs/link'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/fetchUrl', // Your backend endpoint for url data fetching
            }
          },
          Marker: {
            class: require('@editorjs/marker'),
            shortcut: 'CMD+SHIFT+M',
          },
          table: {
            class: require('@editorjs/table'),
          },

          delimiter: require('@editorjs/delimiter'),
          quote: {
            class: require('@editorjs/quote'),
            inlineToolbar: true,
            shortcut: 'CMD+SHIFT+O',
            config: {
              quotePlaceholder: 'Enter a quote',
              captionPlaceholder: 'Quote\'s author',
            },
          },
          attaches: {
            class: require('@editorjs/attaches'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/uploadFile?api_token=' + api_token,
            }
          },
          image: {
            class: require('@editorjs/image'),
            config: {
              additionalRequestHeaders: {
                "Authorization": 'Bearer ' + api_token
              },
              endpoints: {
                byFile: Vue.config.API_URL + 'editor/uploadImage', // Your backend file uploader endpoint

              }

            }
          },
          warning: require('@editorjs/warning'),
          paragraph: {
            class: require('@editorjs/paragraph'),
            inlineToolbar: true,
          },
          checklist: {
            class: require('@editorjs/checklist'),
            inlineToolbar: true,
          },
          map:{
            class:MapPlugin,
            config:{
              url:"https://api.artemdev.ru/api/editor/search_adress",
            }
          }
        },
        "data": {
          "time": 1591362820044,
          "blocks": [
            {
              "type": "header",
              "data": {
                "text": "Название вашего замечательного проекта!",
                "level": 2
              }
            },
            {
              "type": "paragraph",
              "data": {
                "text": "Здесь могут быть описано базовое описание вашего проекта. а также разных требований например:",
              }
            },
            {
              "type": "list",
              "data": {
                "style": "unordered",
                "items": [
                  "Знать Laravel",
                  "Уметь работать с Vue.js",
                  "Уметь работать с REST API"
                ]
              }
            }
          ]
        }
      };
    },
    LoginCheckCode() {

      if (this.islogin) {
        clearInterval(this.timer_check_code);
      }

      var app = this;
      var random_code = app.random_code;
      try{
        var type="normal";




        Api.LoginCheckCode(random_code,type, function (data) {

          app.modals.add_project = false;

          UserModel.set(data.user,true);
          clearInterval(app.timer_check_code);


          eventBus.$emit('reload', data.user);
          document.location.reload();


          this.modal_add_title = "Размещение проекта";



          if (app.show_modal_after_login == true) {

            app.modals.add_project = true;
          } else {
            app.modals.add_project = false;
          }
        })
      }catch(e){

      }


    },
    updateNotifyCount() {
      if (!this.$store.getters.ISAUTH) {
        clearInterval(this.timer);
      }
      var app = this;

      Api.loadNotifyCount(function (notifys) {


        app.notify_count = notifys.count;


      });
    },
    editWork() {
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Сохранить изменения";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    addPost() {
      this.show_modal_after_login = true
      this.is_add_task = false;
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Добавить пост";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    editPost() {
      this.loaded_categorys=false;
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = true;


      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Редактировать пост";

      this.loaded_categorys=false;
      this.categorys=null;
     this.categorys=[this.modal_params.category_post];

      this.form.category = this.modal_params.category;
      this.loaded_categorys=true;


      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    editLead(){

      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = false;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Отредактировать";

      if(this.modal_params.json){
        this.$refs.editor._data.state.editor.render(this.modal_params.json);
      }

    },
    addLead(){
      this.is_disable_editor=true;
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Добавить сделку";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    addItem(){
      var app=this;
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_add_item=true;
      this.is_show_category = false;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      if(app.modal_params.type=='edititem'){
        this.modal_btn_add_project = "Редактировать товар";
      }else {
        this.modal_btn_add_project = "Создать товар";
      }

      this.$refs.editor._data.state.editor.render(this.modal_params.json);

      this.form=null;
      this.form=this.modal_params.newItem;
    },
    addWork() {
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Добавить работу";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    addTask() {
      this.show_modal_after_login = true;
      this.is_add_task = true;
      this.is_show_category = false;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Добавить задачу";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    editProject() {
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = false;
      this.form.category = null;
      this.modals.add_project = true;

      if(this.modal_params.project.custom_fields) {
        this.form.fields = this.modal_params.project.custom_fields;
      }

      if(this.modal_params.project && this.modal_params.project.main_users){
        this.modal_params['is_edit_share']=true;
        this.form.new_client_id=this.modal_params.project.client_id;
        this.form.new_developer_id=this.modal_params.project.developer_id;
      }
      if(!this.form.fields){
        //var custom_fields={};
        this.form.fields={};
        var parent=this;
        this.modal_params.project.fields.map(function(field) {
              var new_field={};
              parent.form.fields[field.name]="";
              if(field.type=="selectinsert"){
                parent.form.fields[field.name+"_input"]="";
              }



            }


        )


      }





      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Сохранить изменения!";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    addProject(show_modal_after_login = true) {


      if (this.islogin) {
        this.modal_add_title = "Размещение проекта";
      } else {
        this.modal_add_title = "Авторизация в системе";
      }
      this.show_modal_after_login = show_modal_after_login;
      this.is_add_task = false;
      this.modal_params = {};
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      if (this.islogin) {
        this.$refs.editor._data.state.editor.render(this.config.data);
      }

      this.modal_btn_add_project = "Отправить на оценку";

    },
    loadNotify() {
      var app = this;
      app.is_notify_load = false;
      app.notify_counts.comments = 0;
      app.notify_counts.freelance = 0;
      app.notify_counts.projects = 0;
      app.notify_counts.invoices = 0;
      Api.loadNotify(app.notify, function (notifys) {

        var projects_count = 0;
        var freelance_count = 0;
        var invoices_count = 0;
        var comments_count = 0;
        if (notifys.length) {
          notifys.forEach(function callback(currentValue, index, array) {
            if (currentValue.isread == 0 && currentValue.json.type == "projects") {
              projects_count++;
            }
            if (currentValue.isread == 0 && currentValue.json.type == "freelance") {
              freelance_count++;
            }
            if (currentValue.isread == 0 && currentValue.json.type == "comments") {
              comments_count++;
            }
            if (currentValue.isread == 0 && currentValue.json.type == "invoices") {
              invoices_count++;
            }
          })
          app.notify_counts.comments = comments_count;
          app.notify_counts.freelance = freelance_count;
          app.notify_counts.projects = projects_count;
          app.notify_counts.invoices = invoices_count;
        }


        app.notifys = notifys;
        app.is_notify_load = true;

      });
    },
    markerAllNotifyRead() {
      var app = this;
      Api.setReadAllNotify(function () {
        app.notify_count = 0;
        app.notifys = [];
        app.is_notify_load = false;
        app.notify_counts.comments = 0;
        app.notify_counts.freelance = 0;
        app.notify_counts.projects = 0;
        app.notify_counts.invoices = 0;
        app.loadNotify();
      });
    },
    invokeSave() {
      var app = this;
      if (app.modal_params.type && app.modal_params.type == "post_new") {
        {
          this.$refs.editor._data.state.editor.save()
              .then((data) => {
                // Do what you want with the data here

                var app = this;
                var newPost = app.form;
                newPost.json = data;
                Api.createPost(newPost, function (result) {
                  if (result.iserror == false) {
                    app.iserror = false;
                    app.modals.add_project = false;
                    app.form = {};
                    app.$refs.editor._data.state.editor.clear();
                    document.location = "/post/"+result.alias+"/" + result.post_id+"/";
                  } else {
                    app.iserror = true;
                    app.error_message = result.error_message;
                  }
                });



              })
              .catch(err => {

              })
        }
      }else if(app.modal_params.type=="editlead"){

        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              // Do what you want with the data here

              var app = this;
              var newPost = {}
              newPost.json = data;
              var lead_id=app.modal_params.lead_id;
              Api.updateLead(newPost,lead_id, function (data) {
                app.iserror=false;
                app.modals.add_project = false;
                app.$router.push({name: 'lead', params: {id: data.lead_id, "rand": Math.random()}});

              },function(error){
                app.iserror = true;
                app.error_message = error;
              });



            })
            .catch(err => {

            })
      } else if(app.modal_params.type=="addlead"){
        var custom_fields=app.modal_params.fields_value;
        var funnel_id=app.modal_params.funnel_id;
        var category_id=app.form.category;
        var json_request={
          "category":category_id,
          "funnel_id":funnel_id,
          "lead_data":custom_fields,
          "json":{
            "blocks":[
              {
                "type": "header",
                "data": {
                  "text": "Безымянный проект",
                  "level": 2
                }
              },
              {
                "type" : "paragraph",
                "data" : {
                  "text" : "Без какого либо описания",
                }
              }
            ]
          }
        };
        Api.addLead(json_request,function(data){


          app.iserror = false;
          app.modals.add_project = false;
          app.$router.push({name: 'lead', params: {id: data.lead_id, "rand": Math.random()}});

        },function(error){
          app.iserror = true;
          app.error_message = error;
        });

      }else if (app.modal_params.type && app.modal_params.type == "post_edit") {
        {
          this.$refs.editor._data.state.editor.save()
              .then((data) => {
                // Do what you want with the data here

                var app = this;
                var newPost = app.form;
                newPost.json = data;
                newPost.last_id = app.modal_params.post_id;
                Api.createPost(newPost, function (result) {
                  if (result.iserror == false) {
                    app.iserror = false;
                    app.modals.add_project = false;
                    app.form = {};
                    app.$refs.editor._data.state.editor.clear();
                    //  app.is_load_projects = false;

                    //document.location = "/post/"+result.alias+"/" + result.post_id+"/";

                    app.$router.push({name: 'post', params: {alias:result.alias,id: result.post_id, "rand": Math.random()}});
                  } else {
                    app.iserror = true;
                    app.error_message = result.error_message;
                  }
                });



              })
              .catch(err => {

              })
        }
      } else if (app.modal_params.type && app.modal_params.type == "edit") {


        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              var custom_fields={};
              if(app.form.fields){
                //custom_fields=app.form.fields;

                //custom_fields=app.form.fields;




                Object.keys(app.form.fields).forEach(key => {
                  const element = app.form.fields[key];

                  custom_fields[key]=element;
                  // ...
                })


              }

              // Do what you want with the data here

              var edit_project = {'fields':custom_fields,"last_id": app.modal_params.project_id, "json": data};
              if(app.form.new_developer_id && app.modal_params.is_edit_share  && app.modal_params.is_edit_share==true){
                edit_project["new_developer_id"]=app.form.new_developer_id;
              }
              if(app.form.new_client_id && app.modal_params.is_edit_share  && app.modal_params.is_edit_share==true){
                edit_project["new_client_id"]=app.form.new_client_id;
              }
              Api.editProject(edit_project, function () {
                app.iserror = false;
                app.modals.add_project = false;
                eventBus.$emit("update_project_info", {json: edit_project.json})
                {


                }

                app.$refs.editor._data.state.editor.clear();

              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })
            })
            .catch(err => {

            })
      } else if(app.modal_params.type && (app.modal_params.type == "additem" || app.modal_params.type == "edititem")){
        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              var newItem=app.form;
              newItem.content_json=data;

              Api.addItem(newItem, function () {
                app.iserror = false;
                app.data = [];
                Api.loadShopItems();
                app.form={
                  'category': null,
                  'json': {},
                  'fields':{},
                };
                app.config.blocks = null;
                app.modals.add_project = false;
                app.$refs.editor._data.state.editor.clear();
              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })

            })
            .catch(err => {

            })
      }else if (app.modal_params.type && (app.modal_params.type == "addwork" || app.modal_params.type == "editwork")) {
        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              var newWork = app.modal_params.newWork;
              newWork.json = data;
              Api.addWork(newWork, function () {
                app.iserror = false;
                app.data = [];
                Api.loadUserPortfolio();
                app.config.blocks = null;
                app.modals.add_project = false;
                app.$refs.editor._data.state.editor.clear();
              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })

            })
            .catch(err => {

            })
      } else if (app.modal_params.type && app.modal_params.type == "addtask") {
        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              var edit_project = {"last_id": app.modal_params.project_id, "json": data};
              edit_project.developer = app.new_task_developer;
              Api.addTask(edit_project, function (tasks) {
                app.iserror = false;
                app.modals.add_project = false;
                app.is_add_task = false;
                eventBus.$emit("update_project_tasks", {tasks: tasks})
                {


                }


                app.$refs.editor._data.state.editor.clear();

              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })
            })
            .catch(err => {

            })


      } else {
        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              // Do what you want with the data here

              var app = this;
              var newTask = app.form;
              newTask.json = data;
              Api.createProject(newTask, function (result) {
                if (result.iserror == false) {
                  app.iserror = false;
                  app.modals.add_project = false;
                  app.form = {};
                  app.$refs.editor._data.state.editor.clear();
                  app.is_load_projects = false;
                  document.location = "/project/" + result.project_id;
                  app.$router.push({name: 'project', params: {id: result.project_id, "rand": Math.random()}});
                } else {
                  app.iserror = true;
                  app.error_message = result.error_message;
                }
              });



            })
            .catch(err => {

            })
      }


    },
    clickNotify(button, notify, notify_index) {


      var app = this;
      Api.setReadNotify(notify.last_id, function () {

        if (app.notify.show_only_unread == true) {
          app.loadNotify();
        }
        if (button.type == "load_invoice") {
          app.$router.push({"name": "invoice", "params": {"id": button.params.invoice_id, "rand": Math.random()}});
          // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // vm.$forceUpdate();
        }
        if (button.type == "load_project") {
          app.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // vm.$forceUpdate();

        }
        if (button.type == "remove_notify") {
          Api.setRemoveNotify(notify.last_id, function () {
            app.loadNotify();
          });
        }
      });

    },
    telegramLoginCallback(user) {

      // gets user as an input
      // id, first_name, last_name, username,
      // photo_url, auth_date and hash

      var app = this;
      app.modals.add_project = false;

      axios.post(Vue.config.API_URL + `login`, user)
          .then(response => {

            if (response.data.type == "success") {

              var data=response.data;
              app.modals.add_project = false;

              UserModel.set(data.user,true);
              clearInterval(app.timer_check_code);


              eventBus.$emit('reload', data.user);
              document.location.reload();


              this.modal_add_title = "Размещение проекта";



              if (app.show_modal_after_login == true) {

                app.modals.add_project = true;
              } else {
                app.modals.add_project = false;
              }
            } else {
              alert(response.data.message);
            }
          })
          .catch(e => {

          })
    }
  }
}
</script>

<style scoped>

</style>